import React, { useState, useEffect } from 'react'
import './index.scss'
import Product from '../../components/Product'
import shippingBagIcon from '../../assets/images/ic_shoppingbag.png'
import orderlistIcon from '../../assets/images/ic_myorder.png'
import { isMiniProgram } from 'bxl-miniParse'
import TopBlock from '../TopBlock'
const ProductList = props => {
    const { productList, handleClickItem, left, cartNum, toOrderCart } = props
    const [isMini, setisMini] = useState(false)
    useEffect(() => {
        isMiniProgram().then(res => {
            if (res) {
                setisMini(true)
            }
        })
    }, [])
    return (
        <div className={`productList ${left ? 'left' : ''}`}>
            {/* <TopBlock></TopBlock> */}
            {productList &&
                productList.map((item, index) => {
                    return (
                        <Product
                            key={`product${index}`}
                            product={item?.searchProduct}
                            handleClickItem={handleClickItem}
                        ></Product>
                    )
                })}
            {!isMini && (
                <div className="routerIcon">
                    <div
                        className="toCartIcon"
                        onClick={() => toOrderCart('cart')}
                    >
                        <div className="imgContent">
                            {cartNum && (
                                <div className="cartNum">{cartNum}</div>
                            )}
                            <img src={shippingBagIcon} alt=""></img>
                        </div>
                    </div>
                    <div
                        className="toListIcon"
                        onClick={() => toOrderCart('order-list')}
                    >
                        <div className="imgContent">
                            <img src={orderlistIcon} alt=""></img>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default ProductList
